
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#0C1D59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 12h1.027a4.5 4.5 0 008.877.427A.996.996 0 0011 12a1 1 0 112 0c0 .153.034.298.096.427A4.502 4.502 0 0021.973 12H23a1 1 0 100-2h-1.256a4.502 4.502 0 00-8.23-.59A2.986 2.986 0 0012 9c-.552 0-1.07.15-1.514.41a4.502 4.502 0 00-8.23.59H1a1 1 0 100 2zm5.5-3a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm8.5 2.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z"}})])
          )
        }
      }
    